module.exports = __webpack_public_path__ + "img/zxicon.aa69aa55.png";